<template>
  <v-ons-page class="ja-material-select page">
    <common-header>
      <template #header>
        <span class="header-title">
          写真・動画を選択する
          {{
            selectedMaterialIdList.length -
            selectedMaterialIdList.filter((materialId) => materialId === -1).length
          }}/{{ TEMPLATES[templateId].TEMPLATE_MATERIAL_LENGTH }}
        </span>
        <div class="header-menu-wrapper">
          <div class="header-menu">
            <button class="menu-button" @click="setIsOpenHeaderMenu(true)">
              <img :src="ICON_DOTS" alt="メニュー" />
            </button>
            <transition-group>
              <template v-if="isOpenHeaderMenu">
                <div class="header-menu-list" key="header-menu-list">
                  <div class="header-menu-item display-mode-header">メディア表示モード</div>
                  <div class="header-menu-item display-mode-item">
                    <div
                      class="display-mode-check-icon-wrapper"
                      v-show="materialDisplayMode === MATERIAL_DISPLAY_MODE_LIST.ALL"
                    >
                      <v-ons-icon icon="fa-check" size="2rem" />
                    </div>
                    <button
                      class="header-menu-item display-mode-button"
                      @click="onClickDisplayModeButton(MATERIAL_DISPLAY_MODE_LIST.ALL)"
                    >
                      全表示
                    </button>
                  </div>
                  <div class="header-menu-item display-mode-item">
                    <div
                      class="display-mode-check-icon-wrapper"
                      v-show="materialDisplayMode === MATERIAL_DISPLAY_MODE_LIST.SELF"
                    >
                      <v-ons-icon icon="fa-check" size="2rem" />
                    </div>
                    <button
                      class="header-menu-item display-mode-button"
                      @click="onClickDisplayModeButton(MATERIAL_DISPLAY_MODE_LIST.SELF)"
                    >
                      自分のメディア
                    </button>
                  </div>
                  <div class="header-menu-item display-mode-item">
                    <div
                      class="display-mode-check-icon-wrapper"
                      v-show="materialDisplayMode === MATERIAL_DISPLAY_MODE_LIST.TEMPLATE"
                    >
                      <v-ons-icon icon="fa-check" size="2rem" />
                    </div>
                    <button
                      class="header-menu-item display-mode-button"
                      @click="onClickDisplayModeButton(MATERIAL_DISPLAY_MODE_LIST.TEMPLATE)"
                    >
                      テンプレメディア
                    </button>
                  </div>
                  <div class="header-menu-item display-mode-item">
                    <div
                      class="display-mode-check-icon-wrapper"
                      v-show="materialDisplayMode === MATERIAL_DISPLAY_MODE_LIST.SHARE"
                    >
                      <v-ons-icon icon="fa-check" size="2rem" />
                    </div>
                    <button
                      class="header-menu-item share-mode-button"
                      @click="onClickDisplayModeButton(MATERIAL_DISPLAY_MODE_LIST.SHARE)"
                    >
                      他直売所のメディア
                    </button>
                  </div>
                  <div class="header-menu-item">
                    <button class="delete-mode-button" @click="onClickDeleteModeButton()">
                      削除モード
                    </button>
                  </div>
                </div>
                <button
                  @click="setIsOpenHeaderMenu(false)"
                  class="header-menu-list-mask"
                  key="header-menu-list-mask"
                />
              </template>
            </transition-group>
          </div>
        </div>
      </template>
    </common-header>
    <div v-show="displayState === DISPLAYSTATE.LOADING_DONE">
      <div class="materials">
        <ja-material-add-button
          v-show="isShowAddButton"
          :getMaterial="getMaterial"
          :resetPollingInterval="resetPollingInterval"
        />
        <ja-material-select-cell
          v-for="emptyMaterial in emptyMaterials"
          :key="emptyMaterial.materialUrl"
          :material="emptyMaterial"
        />
        <ja-material-select-cell
          v-show="isShowSelfMaterial"
          v-for="selfMaterial in selfMaterials"
          :key="selfMaterial.materialId"
          :material="selfMaterial"
          :selectedMaterialIdList="selectedMaterialIdList"
          :clickMaterial="clickMaterial"
          :getMaterial="getMaterial"
        />
        <ja-material-select-cell
          v-show="isShowTemplateMaterial"
          v-for="templateMaterial in templateMaterials"
          :key="templateMaterial.materialId"
          :material="templateMaterial"
          :selectedMaterialIdList="selectedMaterialIdList"
          :clickMaterial="clickMaterial"
        />
        <ja-material-select-cell
          v-show="isShowShareMaterial"
          v-for="shareMaterial in shareMaterials"
          :key="shareMaterial.materialId"
          :material="shareMaterial"
          :selectedMaterialIdList="selectedMaterialIdList"
          :clickMaterial="clickMaterial"
        />
      </div>
    </div>
    <progress-circular v-show="displayState === DISPLAYSTATE.LOADING_PROGRESS"> </progress-circular>
    <common-footer class="common-footer d-flex">
      <template #footer>
        <v-ons-row class="footer-preview-explain-area">
          <div class="footer-preview-area">
            <ja-content-preview
              :class="[
                HORIZONTAL_TEMPLATES[templateId]
                  ? 'ja-content-horizontal-footer-preview'
                  : 'ja-content-vertical-footer-preview',
              ]"
              :processNum="CREATE_CONTENT_PROCESS_NUM.MATERIAL_SELECT"
              :templateId="templateId"
              :contentMaterialList="selectedContentMaterialList"
            />
          </div>
          <span class="footer-explain-area">
            写真か動画を<br />
            <b class="footer-template-material-length">
              {{ TEMPLATES[templateId].TEMPLATE_MATERIAL_LENGTH }}点
            </b>
            選択してください
          </span>
        </v-ons-row>
        <v-ons-row class="footer-button-area">
          <small-button
            class="footer-back-button"
            title="戻る"
            :disabled="false"
            @click="moveBackButton"
          />
          <small-button
            class="footer-next-button"
            title="次へ"
            :disabled="isNextButtonDisable"
            @click="moveToNextScreen"
          />
        </v-ons-row>
      </template>
    </common-footer>
  </v-ons-page>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import CommonHeader from '@/components/common/CommonHeader.vue';
import CommonFooter from '@/components/common/CommonFooter.vue';
import SmallButton from '@/components/common/SmallButton.vue';
import JaContentPreview from '@/components/JaContent/JaContentPreview.vue';
import ProgressCircular from '@/components/common/ProgressCircular.vue';
import JaMaterialSelectCell from '@/components/JaContent/JaMaterialSelectCell.vue';
import JaMaterialAddButton from '@/components/JaContent/JaMaterialAddButton.vue';
import {
  MATERIAL_UPLORD_STATUS,
  HORIZONTAL_TEMPLATES,
  TEMPLATES,
  ICON_DOTS,
  CREATE_CONTENT_PROCESS_NUM,
} from '@/composable/constant_common';
import { deleteFailureUploadMaterials } from '@/composable/data_push_common';
import { stopPolling } from '@/composable/material_common';
import { fetchPendingMaterialList, dataFetchMaterials } from '@/composable/data_fetch_common';
import { disableScroll, enableScroll } from '@/composable/common';

// VuexストアとVue Routerのインスタンスを取得
const store = useStore();
const router = useRouter();

// 自分の素材一覧
const selfMaterials = ref([]);
// テンプレ素材一覧
const templateMaterials = ref([]);
// 他直売所メディア
const shareMaterials = ref([]);
// 選択された素材ID一覧
const selectedMaterialIdList = ref([]);
// 選択された素材情報一覧
const selectedContentMaterialList = ref([]);

// ローディング完了フラグ
const isLoadingDone = ref(false);
const pollingInterval = ref(null);
// 比較用マテリアルリスト
const beforeMaterialStore = ref([]);
// 空箱用のマテリアルリスト
const emptyMaterials = ref([]);

// ローディングステータス
const DISPLAYSTATE = {
  LOADING_PROGRESS: 'ロード中',
  LOADING_DONE: 'ロード完了',
};

// 素材表示モードリスト
const MATERIAL_DISPLAY_MODE_LIST = {
  ALL: 0,
  SELF: 1,
  TEMPLATE: 2,
  SHARE: 3,
};

// ヘッダメニュー関連の状態
const isOpenHeaderMenu = ref(false);
const materialDisplayMode = ref(0);

// テンプレートID
const templateId = computed(() => store.getters['content/getTemplateId']);

// 画面表示状態
const displayState = computed(() =>
  isLoadingDone.value ? DISPLAYSTATE.LOADING_DONE : DISPLAYSTATE.LOADING_PROGRESS
);

// 「次へ」ボタン活性判定処理
const isNextButtonDisable = computed(() => {
  const isTemplateMaterialLength =
    selectedMaterialIdList.value.length !== TEMPLATES[templateId.value].TEMPLATE_MATERIAL_LENGTH;
  return isTemplateMaterialLength || selectedMaterialIdList.value.includes(-1);
});

// 全てのメディアもしくはテンプレメディアの時だけ表示
const isShowSelfMaterial = computed(() =>
  [MATERIAL_DISPLAY_MODE_LIST.ALL, MATERIAL_DISPLAY_MODE_LIST.SELF].includes(
    materialDisplayMode.value
  )
);

// 全てのメディアもしくは自分のメディアの時だけ表示
const isShowTemplateMaterial = computed(() =>
  [MATERIAL_DISPLAY_MODE_LIST.ALL, MATERIAL_DISPLAY_MODE_LIST.TEMPLATE].includes(
    materialDisplayMode.value
  )
);

// 他直売所メディアの時だけ表示
const isShowShareMaterial = computed(() =>
  [MATERIAL_DISPLAY_MODE_LIST.SHARE].includes(materialDisplayMode.value)
);

// 追加ボタンの表示制御
const isShowAddButton = computed(() =>
  [
    MATERIAL_DISPLAY_MODE_LIST.ALL,
    MATERIAL_DISPLAY_MODE_LIST.SELF,
    MATERIAL_DISPLAY_MODE_LIST.TEMPLATE,
  ].includes(materialDisplayMode.value)
);

// マテリアルアップロードステータスをフィルタリング
const filterMaterialUploadStatus = () => {
  const materialStore = store.getters['materialStore/getMaterialUploadingList'];
  return materialStore.filter(
    (item) =>
      item.materialUploadStatus === MATERIAL_UPLORD_STATUS.MATERIAL_NOT_REGISTERED ||
      item.materialUploadStatus === MATERIAL_UPLORD_STATUS.MATERIAL_REGISTERED_ERR
  );
};
// 素材取得処理
const getMaterial = async () => {
  beforeMaterialStore.value = store.getters['materialStore/getMaterialUploadingList'];
  isLoadingDone.value = false;
  const materials = await dataFetchMaterials(); // 素材一覧の取得
  emptyMaterials.value = filterMaterialUploadStatus();
  selfMaterials.value = materials.selfMaterialList;
  templateMaterials.value = materials.templateMaterialList;
  shareMaterials.value = materials.shareMaterialList;
  isLoadingDone.value = true;

  // ポーリングを開始
  if (pollingInterval.value == null) {
    if (beforeMaterialStore.value.length >= 1) {
      // eslint-disable-next-line no-use-before-define
      pollingInterval.value = setInterval(() => startPolling(beforeMaterialStore.value), 3000);
    }
  }
};

// マテリアルストアの情報を更新
const updatedMaterialList = async () => {
  const materialStore = store.getters['materialStore/getMaterialUploadingList'];
  const materialUrlList = materialStore.map((item) => item.materialUrl);
  const fetchMaterialList = await fetchPendingMaterialList(materialUrlList);

  const updatedMaterialStore = materialStore.map((material) => {
    const updatedMaterial = { ...material };
    fetchMaterialList.materialUploadStatusList.forEach((fetchMaterial) => {
      if (updatedMaterial.materialUrl === fetchMaterial.materialUrl) {
        updatedMaterial.materialUploadStatus = fetchMaterial.materialUploadStatus;
      }
    });
    return updatedMaterial;
  });

  const filteredMaterialStore = updatedMaterialStore.filter(
    (material) => material.materialUploadStatus !== MATERIAL_UPLORD_STATUS.MATERIAL_UPLOADED
  );

  store.commit('materialStore/setMaterialUploadingList', filteredMaterialStore);
};

// ポーリング開始
function startPolling(previousMaterialStore) {
  const currentMaterialStore = store.getters['materialStore/getMaterialUploadingList'];
  if (currentMaterialStore.length >= 1) {
    updatedMaterialList();
    if (JSON.stringify(previousMaterialStore) !== JSON.stringify(currentMaterialStore)) {
      getMaterial();
    }
  } else {
    getMaterial();
    stopPolling(pollingInterval.value);
  }
}

const resetPollingInterval = () => {
  if (pollingInterval.value) {
    stopPolling(pollingInterval.value);
    pollingInterval.value = null;
  }
};

// ヘッダメニューの表示状態を設定
const setIsOpenHeaderMenu = (isOpen) => {
  isOpenHeaderMenu.value = isOpen;
  if (isOpen) {
    disableScroll(); // スクロールを無効化
  } else {
    enableScroll(); // スクロールを有効化
  }
};

// 素材削除処理
const deleteFailureMaterials = () => {
  if (
    selfMaterials.value.some(
      (material) => material.materialUploadStatus === -1 || material.materialUploadStatus === -2
    )
  ) {
    deleteFailureUploadMaterials();
  }

  const materialStore = store.getters['materialStore/getMaterialUploadingList'];

  // 引数の日付・時間から4分経過しているか判定する処理
  const hasFourMinutesPassed = (createTime) => {
    const targetDate = new Date(
      createTime.slice(0, 4),
      createTime.slice(4, 6) - 1,
      createTime.slice(6, 8),
      createTime.slice(8, 10),
      createTime.slice(10, 12),
      createTime.slice(12, 14)
    );
    const currentDate = new Date();
    const diffMilliseconds = currentDate - targetDate;
    const diffMinutes = diffMilliseconds / (1000 * 60);
    return diffMinutes > 4;
  };

  const filteredMaterialStore = materialStore.filter(
    (material) =>
      material.materialUploadStatus !== MATERIAL_UPLORD_STATUS.MATERIAL_DELETE &&
      material.materialUploadStatus !== MATERIAL_UPLORD_STATUS.MATERIAL_REGISTERED_ERR &&
      !hasFourMinutesPassed(material.createTime)
  );

  store.commit('materialStore/setMaterialUploadingList', filteredMaterialStore);
};

// 素材削除モードに移動
const onClickDeleteModeButton = () => {
  stopPolling();
  deleteFailureMaterials();
  setIsOpenHeaderMenu(false);
  // Vuexストアのコミット
  store.commit('content/setMaterialIdList', []);
  store.commit('content/setContentMaterialList', []);
  // Vue Routerでリダイレクト
  router.replace('/ja/content/materialDelete');
};

// 前画面遷移処理
const moveBackButton = () => {
  stopPolling(pollingInterval.value);
  router.back();
  deleteFailureMaterials();
};

// 次画面遷移処理
const moveToNextScreen = () => {
  router.push('/ja/content/contentConfirm');
  stopPolling(pollingInterval.value);
  deleteFailureMaterials();
};

// 素材選択処理
function clickMaterial(materialId, materialUrl, materialDuration) {
  const index = selectedMaterialIdList.value.indexOf(materialId);

  if (index === -1) {
    // 未選択 → 選択の場合
    if (
      selectedMaterialIdList.value.length < TEMPLATES[templateId.value].TEMPLATE_MATERIAL_LENGTH &&
      !selectedMaterialIdList.value.includes(-1)
    ) {
      // テンプレートの素材数以下の場合
      selectedMaterialIdList.value.push(materialId);
      selectedContentMaterialList.value.push({
        materialUrl,
        materialDuration,
        offsetX: 0,
        offsetY: 0,
        scale: 0,
        isAudioEnabled: 1,
      });
    } else if (selectedMaterialIdList.value.includes(-1)) {
      // 既存のリストに未選択のスロットがある場合
      const unselectedIndex = selectedMaterialIdList.value.indexOf(-1);
      selectedContentMaterialList.value[unselectedIndex] = {
        materialUrl,
        materialDuration,
        offsetX: 0,
        offsetY: 0,
        scale: 0,
        isAudioEnabled: 1,
      };
      selectedMaterialIdList.value[unselectedIndex] = materialId;
    }
  } else {
    // 選択済み → 未選択の場合
    selectedMaterialIdList.value[index] = -1;
    selectedContentMaterialList.value[index] = {};
  }

  // Vuexストアにコミット
  store.commit('content/setMaterialIdList', selectedMaterialIdList.value);
  store.commit('content/setContentMaterialList', selectedContentMaterialList.value);
}

// 素材表示モード変更
const onClickDisplayModeButton = (newDisplayMode) => {
  setIsOpenHeaderMenu(false);
  materialDisplayMode.value = newDisplayMode;
};

// onMountedで初期処理
onMounted(() => {
  getMaterial();
  selectedMaterialIdList.value = store.getters['content/getMaterialIdList'];
  selectedContentMaterialList.value = store.getters['content/getContentMaterialList'];
});
</script>
<style scoped>
/* ヘッダ */
.ja-material-select {
  margin: auto;
}
.header-title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

/* ヘッダメニュー */
.header-menu-wrapper {
  right: 1rem;
  position: absolute;
}
.header-menu {
  position: relative;
}
.menu-button {
  border: none;
  background-color: inherit;
}
.menu-button:hover,
.display-mode-button:hover,
.share-mode-button:hover,
.delete-mode-button:hover {
  opacity: 0.8;
}
.header-menu-list {
  position: absolute;
  top: 100%;
  right: 0;
  width: 23rem;
  box-sizing: border-box;
  background-color: white;
  border: 1px #ddd solid;
  border-radius: 0.5rem;
  z-index: 2;
}
.header-menu-list-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  border: none;
  z-index: 1;
}
.header-menu-item {
  width: 100%;
  box-sizing: border-box;
  font-weight: normal;
}
.header-menu-item,
.header-menu-item * {
  font-size: 1.8rem;
}
.display-mode-header {
  padding: 1rem 3rem;
  font-size: 1.8rem;
}
.display-mode-item {
  position: relative;
}
.display-mode-check-icon-wrapper {
  position: absolute;
  left: 0;
  display: flex;
  width: 3rem;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.display-mode-button,
.share-mode-button,
.delete-mode-button {
  border: none;
  background-color: inherit;
  width: 100%;
  text-align: left;
  padding-block: 1rem;
}
.display-mode-button {
  padding-left: 4.2rem;
  color: #222;
}
.share-mode-button {
  padding-left: 3rem;
  color: #222;
}
.delete-mode-button {
  color: red;
  padding-left: 3rem;
}

/* ヘッダメニューのアニメーション  */
.v-enter-active,
.v-leave-active {
  transition: all 0.1s ease;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}

/* 素材ラッパー */
.materials {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: #fff;
  padding-top: 10vh;
  padding-top: 10dvh;
  padding-bottom: 23rem;
  z-index: 1;
}

/* フッタ */
.common-footer {
  height: 23rem;
  flex-direction: column;
}
.footer-preview-explain-area {
  width: 90%;
  height: 60%;
}
.footer-preview-area {
  box-sizing: border-box;
  height: 100%;
  width: 50%;
  padding: 1rem;
  padding-left: 2.5%;
  padding-top: 2rem;
}
.ja-content-horizontal-footer-preview {
  width: 100%;
  height: 100%;
  margin: auto;
}
.ja-content-vertical-footer-preview {
  width: 40%;
  height: 100%;
  margin: auto auto auto 0;
}
.footer-explain-area {
  width: 45%;
  margin: auto;
  padding: 0.5rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
}
.footer-template-material-length {
  font-weight: 700;
}
.footer-button-area {
  width: 90%;
  height: 30%;
  padding-bottom: 1rem;
}
.footer-back-button {
  background: #fff;
  border: solid 1px #cccccc;
  color: #222222;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 25%;
}
.footer-next-button {
  box-shadow: 0rem 0.2rem #21963b;
  color: #fff;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 65%;
}
.footer-back-button:hover,
.footer-next-button:hover {
  opacity: 0.8;
}
@media screen and (min-width: 840px) {
  .materials {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }
}
</style>
